"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[711],{

/***/ 47597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CategoryListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var CategoryListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MAKECATEGORYS */ .Z.MAKECATEGORYS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CategoryListSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 82313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RN": function() { return /* binding */ postPackaging; },
/* harmony export */   "Ri": function() { return /* binding */ PackagingApi; },
/* harmony export */   "d3": function() { return /* binding */ InsertPackaging; },
/* harmony export */   "hU": function() { return /* binding */ ItemCheckPackaging; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 견적 등록
var InsertPackaging = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGING */ .Z.PACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function InsertPackaging(body) {
        return _ref.apply(this, arguments);
    };
}();
// 견적 검증
var ItemCheckPackaging = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGING */ .Z.PACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ItemCheckPackaging(body) {
        return _ref.apply(this, arguments);
    };
}();
// 마이페이지 견적 관리
var postPackaging = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGING */ .Z.PACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postPackaging(body) {
        return _ref.apply(this, arguments);
    };
}();
// packaging 공통
var PackagingApi = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGING */ .Z.PACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PackagingApi(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 38172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ PackagingDeleteSet; },
/* harmony export */   "so": function() { return /* binding */ PackagingInsertSet; },
/* harmony export */   "tP": function() { return /* binding */ PackagingListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 견적 바구니 담기
var PackagingInsertSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGINGBASKET */ .Z.PACKAGINGBASKET).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PackagingInsertSet(body) {
        return _ref.apply(this, arguments);
    };
}();
// 견적 바구니 불러오기
var PackagingListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGINGBASKET */ .Z.PACKAGINGBASKET).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PackagingListSet(body) {
        return _ref.apply(this, arguments);
    };
}();
// 바구니 아이템 삭제
var PackagingDeleteSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PACKAGINGBASKET */ .Z.PACKAGINGBASKET).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PackagingDeleteSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 85140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ CustomNewSection; },
/* harmony export */   "BR": function() { return /* binding */ MobileBanner; },
/* harmony export */   "Bo": function() { return /* binding */ BtnWrapper; },
/* harmony export */   "Ce": function() { return /* binding */ CustomMobileTitle; },
/* harmony export */   "DQ": function() { return /* binding */ StepSection; },
/* harmony export */   "EC": function() { return /* binding */ BoxItem; },
/* harmony export */   "Gh": function() { return /* binding */ HeaderTitle; },
/* harmony export */   "Hd": function() { return /* binding */ SideInfoWrapper; },
/* harmony export */   "J": function() { return /* binding */ PortfolioBox; },
/* harmony export */   "JY": function() { return /* binding */ CustomizingCateSection; },
/* harmony export */   "KZ": function() { return /* binding */ CustomizingSliderSection; },
/* harmony export */   "MJ": function() { return /* binding */ CategoryWrapper; },
/* harmony export */   "Sc": function() { return /* binding */ PortfolioSliderArrows; },
/* harmony export */   "Ui": function() { return /* binding */ CateBox; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "WN": function() { return /* binding */ SlideArrows; },
/* harmony export */   "Y_": function() { return /* binding */ ContentBox; },
/* harmony export */   "_n": function() { return /* binding */ StickyContents; },
/* harmony export */   "ef": function() { return /* binding */ BodyWrapper; },
/* harmony export */   "f3": function() { return /* binding */ TypeWrapper; },
/* harmony export */   "h2": function() { return /* binding */ SliderWrapper; },
/* harmony export */   "iJ": function() { return /* binding */ RightSmallSlide; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "i_": function() { return /* binding */ SideImageWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jb": function() { return /* binding */ LeftBigBanner; },
/* harmony export */   "lt": function() { return /* binding */ SideStickyWrapper; },
/* harmony export */   "nz": function() { return /* binding */ SliderTitle; },
/* harmony export */   "oW": function() { return /* binding */ ContentBoxTitle; },
/* harmony export */   "oq": function() { return /* binding */ RightSmallBanner; },
/* harmony export */   "qU": function() { return /* binding */ LeftBigSlide; },
/* harmony export */   "t7": function() { return /* binding */ PortFolioSliderSection; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "wh": function() { return /* binding */ TypeBtn; },
/* harmony export */   "xz": function() { return /* binding */ CustomCartWrapper; }
/* harmony export */ });
/* unused harmony exports HeaderWrapper, StickyHeader, HeaderStepWrapper, HeaderStep, TitleShadow, Sidebar, StepContents, StepWrapper, CategorySection, CategoryRow, SecondCategoryRow, CategoryBox, CheckboxDiv, SelectedStepCommonInfo, SelectedStepBtnWrapper, FooterWrapper, FooterTableWrapper, TableBtn, FooterBtnWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  padding: 10px 0 0 0;\n  margin-bottom: 20px;\n  background-color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 73px;\n  z-index: 998;\n  background-color: white;\n  padding: 10px 110px;\n  padding-left: 110px;\n  border-bottom: 1px solid #ececec;\n  & h2 {\n    width: fit-content;\n    cursor: pointer;\n    margin-bottom: 20px;\n    :hover {\n      color: #198754;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: baseline;\n  /* margin-bottom: 10px; */\n  padding: 0px 25px;\n  & ul {\n    display: flex;\n  }\n  & li {\n    margin-right: 10px;\n    font-size: 1.1rem;\n    :last-of-type {\n      margin-right: 0px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  :hover {\n    color: #198754;\n  }\n\n  & i {\n    margin-left: 10px;\n    padding-top: 1px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 40px;\n  text-align: center;\n  margin: 0 auto 50px auto;\n  width: fit-content;\n  line-height: 1.5;\n  word-break: keep-all;\n\n  & strong {\n    z-index: 2;\n    font-weight: 700;\n    border-bottom: 5px solid #3bb77e;\n  }\n\n  @media screen and (max-width: 991px) {\n    font-size: 36px;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 767px) {\n    font-size: 26px;\n  }\n\n  @media (max-width: 575px) {\n    font-size: 22px;\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 2px;\n  opacity: 0.5;\n  z-index: -1;\n  background-color: #3bb77e;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 20%;\n  word-break: keep-all;\n  margin-top: 0;\n\n  .sidebar-widget {\n    padding: 20px;\n  }\n\n  @media screen and (max-width: 350px) {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 351px) and (max-width: 991px) {\n    width: 100%;\n    & ul {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n    & li {\n      width: 48%;\n    }\n  }\n\n  @media screen and (min-width: 992px) and (max-width: 1200px) {\n    width: 30%;\n  }\n\n  @media screen and (max-width: 1200px) {\n    .sidebar-widget {\n      & h5 {\n        font-size: 1.2rem;\n      }\n      & li {\n        padding: 5px 0.5rem;\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  flex-direction: column;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n  margin: 0 auto;\n  /* overflow: hidden; */\n\n  @media screen and (max-width: 991px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 40rem;\n  display: flex;\n\n  .side_step {\n    display: none !important;\n  }\n  .m_sticky {\n    display: none;\n  }\n\n  @media screen and (max-width: 991px) {\n    flex-direction: column;\n    .side_step {\n      display: flex !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .m_sticky {\n      display: flex;\n    }\n    .pc_sticky {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  width: 60px;\n  min-height: 35rem;\n  margin-right: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #3bb77e;\n  border-radius: 50px;\n  padding: 20px 10px;\n  color: #fff;\n\n  @media screen and (max-width: 991px) {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    min-height: 1rem;\n    margin-right: 0px;\n    padding: 10px;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 767px) {\n    padding: 5px 10px;\n  }\n\n  .step-box {\n    width: 100%;\n    height: 70%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 28px;\n    font-weight: 500;\n\n    .step {\n      opacity: 0.3;\n      cursor: pointer;\n    }\n    .step-active {\n      cursor: pointer;\n      opacity: 1;\n    }\n    @media screen and (max-width: 991px) {\n      display: flex;\n      flex-direction: row;\n    }\n    @media screen and (max-width: 767px) {\n      font-size: 22px;\n    }\n    @media screen and (max-width: 435px) {\n      width: 60%;\n      margin: auto;\n    }\n  }\n\n  .cart {\n    width: 50px;\n    height: 50px;\n    background-color: #fff;\n    border-radius: 50%;\n    position: relative;\n    margin-bottom: 50px;\n    cursor: pointer;\n\n    .icon {\n      width: 100%;\n      height: 100%;\n      color: #3bb77e;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      font-size: 1.5rem;\n\n      .bag-count {\n        width: 20px;\n        height: 20px;\n        font-size: 0.8rem;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        background-color: #3bb77e;\n        color: #fff;\n        top: 5px;\n        right: 5px;\n      }\n    }\n    @media screen and (max-width: 991px) {\n      margin-bottom: 0px;\n      margin-right: 20px;\n      width: 40px;\n      height: 40px;\n      .icon {\n        .bag-count {\n          top: 2px;\n          right: 2px;\n        }\n      }\n    }\n\n    :hover {\n      .hover-cart {\n        display: block;\n      }\n    }\n    .hover-cart {\n      min-width: 350px;\n      max-width: 400px;\n      max-height: 500px;\n      position: absolute;\n      top: 0;\n      left: 100%;\n      border-radius: 10px;\n      background-color: rgba(240, 240, 240, 0.7);\n      z-index: 999;\n      display: none;\n      padding: 10px 15px;\n      -webkit-box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);\n      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);\n      overflow-y: auto;\n\n      .cart-row {\n        display: flex;\n        flex-direction: column;\n        word-break: keep-all;\n        margin-bottom: 10px;\n        color: #7e7e7e;\n        background-color: #fff;\n        border-radius: 10px;\n        padding: 10px;\n\n        .cart-tumbnail {\n          display: flex;\n          align-items: center;\n          word-break: break-all;\n\n          & img {\n            max-width: 100px;\n            max-height: 100px;\n            padding: 10px;\n            margin-right: 10px;\n          }\n          & h6 {\n            color: #7e7e7e;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: pre-wrap;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          }\n        }\n        .cart-info {\n          display: flex;\n          justify-content: space-between;\n          & span {\n            margin-right: 10px;\n          }\n          .info-box {\n            display: flex;\n            flex-direction: column;\n          }\n          .btn-box {\n            display: flex;\n            align-items: flex-end;\n            .btn-danger {\n              padding: 5px 10px !important;\n              background-color: #dc3545;\n              :hover {\n                border-color: #fd7e14;\n                background-color: #fd7e14;\n              }\n            }\n          }\n        }\n      }\n      .cart-btn {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        & a {\n          width: 80%;\n          border-radius: 10px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: 90%;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  @media screen and (max-width: 991px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 460px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  width: ",
        ";\n  width: ",
        ";\n  /* margin: 0 auto; */\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n    width: 100%;\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n    width: 100%;\n  }\n  @media (max-width: 460px) {\n    grid-template-columns: repeat(2, 1fr);\n    width: 100%;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: ",
        ";\n  border-radius: 10px;\n  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n  cursor: pointer;\n  background-color: white;\n\n  .sublist {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    & li:not(:last-of-type) {\n      margin-right: 5px;\n    }\n    & li:last-of-type {\n      & span {\n        display: none;\n      }\n    }\n  }\n\n  :hover {\n    border: ",
        ";\n    /* & img {\n      transform: scale(1.2);\n      -webkit-transform: scale(1.2);\n      transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);\n      -webkit-transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);\n    } */\n  }\n  :last-of-type {\n    margin-right: 0;\n    margin-bottom: 0;\n  }\n\n  & img {\n    height: 60%;\n    margin-bottom: 0.7rem;\n  }\n\n  & h6 {\n    height: 10%;\n    z-index: 5;\n  }\n\n  & ul {\n    height: 10%;\n  }\n\n  @media (max-width: 767px) {\n    height: 13rem;\n    & h6 {\n      font-size: 14px;\n    }\n    & span {\n      font-size: 12px;\n      word-break: keep-all;\n      text-align: center;\n    }\n    & p {\n      font-size: 13px;\n    }\n    & img {\n      width: 6rem !important;\n      height: 6rem !important;\n    }\n    :hover {\n      border: ",
        ";\n      & img {\n        transform: scale(1);\n        -webkit-transform: scale(1);\n        transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);\n        -webkit-transition: all 1.5s cubic-bezier(0, 0, 0.05, 1);\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0.3rem;\n  right: 1rem;\n  z-index: 20;\n  & label {\n    ::before {\n      margin: 0 !important;\n      display: flex !important;\n      border: none !important;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  width: 50%;\n  word-break: keep-all;\n\n  & h5 {\n    margin-bottom: 20px;\n  }\n\n  & li {\n    list-style-type: disc;\n    margin-left: 20px;\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  width: 70%;\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 40%;\n  height: fit-content;\n  position: sticky;\n  top: 150px;\n  display: flex;\n  margin-bottom: 20px;\n  @media screen and (max-width: 991px) {\n    .step_wrapper {\n      display: none;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n  & img {\n    min-width: 35%;\n    max-width: 90%;\n    text-align: center;\n  }\n  @media screen and (max-width: 767px) {\n    width: 70%;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ececec;\n    & a {\n      border: none;\n      background-color: #3bb77e;\n      padding: 0 5px;\n      color: #fff;\n      border-radius: 5px;\n      :hover {\n        opacity: 0.8;\n      }\n    }\n  }\n\n  .title {\n    font-size: 20px;\n    font-weight: 400;\n  }\n\n  .ment {\n    padding-left: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ececec;\n    & li {\n      list-style: disc;\n      font-size: 1rem;\n      word-break: keep-all;\n      margin-bottom: 5px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .title {\n      font-size: 16px;\n    }\n    .ment {\n      & li {\n        font-size: 14px;\n      }\n    }\n  }\n  @media (max-width: 460px) {\n    .ment {\n      & li {\n        font-size: 14px;\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  width: 60%;\n  margin: 0 auto;\n  border-left: 1px solid #ececec;\n  padding-left: 2.5%;\n  margin-left: 2.5%;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (max-width: 767px) {\n    border: none;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-width: 10rem;\n  margin-right: 1rem;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  .size_info {\n    display: flex;\n    align-items: center;\n    position: relative;\n    height: fit-content;\n    font-size: 14px;\n    margin: auto 0 auto 10px;\n    background-color: #3bb77e;\n    color: white;\n    padding: 5px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    :hover {\n      opacity: 0.8;\n    }\n  }\n  .cnt_box {\n    width: 45%;\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 991px) {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    width: 100%;\n  }\n  .radios {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    column-gap: 3%;\n    @media screen and (max-width: 460px) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  margin-bottom: 10px;\n  display: flex;\n  font-size: 20px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: ",
        ";\n  grid-template-columns: repeat(5, 1fr);\n  column-gap: 10px;\n  flex-direction: ",
        ";\n\n  .print_download {\n    background-color: #3e5379;\n    color: white;\n    margin-bottom: 10px;\n    padding: 5px 10px;\n    border-radius: 5px;\n    text-align: center;\n    cursor: pointer;\n    :hover {\n      opacity: 0.8;\n    }\n    width: 45%;\n    @media (max-width: 1024px) {\n      width: 80%;\n    }\n    @media (max-width: 991px) {\n      width: 100%;\n    }\n  }\n  @media (max-width: 991px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 20px;\n  margin-bottom: 20px;\n  border-top: 1px solid #ececec;\n  word-break: keep-all;\n\n  & button:not(:last-of-type) {\n    margin-right: 10px;\n  }\n\n  @media screen and (max-width: 460px) {\n    flex-direction: column;\n    & button {\n      margin: 0 0px 10px 0 !important;\n      width: 100%;\n    }\n  }\n  .btn-secondary {\n    :hover {\n      border-color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-top: 1px solid #ececec;\n  padding-top: 40px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  margin: 0 auto;\n  text-align: center;\n\n  .custome-checkbox .form-check-label::before {\n    margin: 0;\n  }\n\n  > div {\n    display: flex;\n    justify-content: end;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #dc3545;\n\n  :hover {\n    background-color: #e66e61;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: end;\n  margin-bottom: 30px;\n\n  & button:not(:last-of-type) {\n    margin-right: 10px;\n  }\n\n  .btn-secondary {\n    :hover {\n      border-color: #f1c40f;\n      background-color: #f1c40f;\n    }\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: calc((100% - 16px) / 4 * 3);\n  :hover {\n    .slider-arrow {\n      opacity: 1;\n      transition: 0.3s ease;\n    }\n  }\n  .slider-arrow {\n    opacity: 0;\n    transition: 0.3s ease;\n    width: calc(100% + 80px);\n    left: -40px;\n    top: 40%;\n    & span {\n      background-color: #fff;\n      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n      z-index: 10;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n\n  & img {\n    max-height: 350px;\n  }\n  & a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: calc((100% - 16px) / 4 * 1);\n  margin-left: 16px;\n\n  :hover {\n    .slider-arrow {\n      opacity: 1;\n      transition: 0.3s ease;\n    }\n  }\n  .slider-arrow {\n    opacity: 0;\n    transition: 0.3s ease;\n    width: calc(100% + 80px);\n    left: -40px;\n    top: 40%;\n    & span {\n      background-color: #fff;\n      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n      z-index: 10;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  & img {\n    max-height: 350px;\n  }\n  & a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: none;\n  width: 100%;\n  :hover {\n    .slider-arrow {\n      opacity: 1;\n      transition: 0.3s ease;\n    }\n  }\n  .slider-arrow {\n    opacity: 0;\n    transition: 0.3s ease;\n    width: calc(100% + 80px);\n    left: -40px;\n    top: 40%;\n    & span {\n      background-color: #fff;\n      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n      z-index: 10;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: ",
        ";\n  margin-top: 20px;\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  & a {\n    color: #7e7e7e;\n    word-break: keep-all;\n    font-size: 16px;\n    :hover {\n      color: #3bb77e;\n    }\n    @media screen and (max-width: 575px) {\n      font-size: 13px;\n    }\n  }\n\n  & h6 {\n    cursor: pointer;\n    :hover {\n      border-bottom: 1px solid #7e7e7e;\n    }\n  }\n  .cart {\n    cursor: pointer;\n    display: flex;\n    position: relative;\n    > span {\n      white-space: nowrap;\n      margin-right: 20px;\n    }\n    :hover {\n      .hover-cart {\n        display: block;\n      }\n    }\n    .hover-cart {\n      min-width: 350px;\n      max-width: 400px;\n      max-height: 500px;\n      position: absolute;\n      top: 0;\n      right: 0;\n      border-radius: 10px;\n      background-color: rgba(240, 240, 240, 0.7);\n      z-index: 999;\n      display: none;\n      padding: 10px 15px;\n      -webkit-box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);\n      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);\n      overflow-y: auto;\n\n      .cart-row {\n        display: flex;\n        flex-direction: column;\n        word-break: keep-all;\n        margin-bottom: 10px;\n        color: #7e7e7e;\n        background-color: #fff;\n        border-radius: 10px;\n        padding: 10px;\n\n        .cart-tumbnail {\n          display: flex;\n          align-items: center;\n          word-break: break-all;\n\n          & img {\n            max-width: 100px;\n            max-height: 100px;\n            padding: 10px;\n            margin-right: 10px;\n          }\n          & h6 {\n            color: #7e7e7e;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: pre-wrap;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          }\n        }\n        .cart-info {\n          display: flex;\n          justify-content: space-between;\n          & span {\n            margin-right: 10px;\n          }\n          .info-box {\n            display: flex;\n            flex-direction: column;\n          }\n          .btn-box {\n            display: flex;\n            align-items: flex-end;\n            .btn-danger {\n              padding: 5px 10px !important;\n              background-color: #dc3545;\n              :hover {\n                border-color: #fd7e14;\n                background-color: #fd7e14;\n              }\n            }\n          }\n        }\n      }\n      .cart-btn {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        & a {\n          width: 80%;\n          border-radius: 10px;\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  .icon {\n    color: #3bb77e;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    font-size: 1.5rem;\n    .bag-count {\n      width: 20px;\n      height: 20px;\n      font-size: 0.8rem;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      background-color: #3bb77e;\n      color: #fff;\n      top: -8px;\n      right: -8px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .cart {\n      > span {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: none;\n  border-radius: 10px;\n  background-color: ",
        ";\n\n  .title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    line-height: normal;\n    text-align: start;\n    word-break: keep-all;\n    color: ",
        ";\n    & span {\n      font-size: 14px;\n    }\n    & h6 {\n      font-size: 20px;\n      font-weight: 600;\n      font-style: normal;\n      text-align: start;\n      color: ",
        ";\n    }\n  }\n  .icon {\n    font-size: 40px;\n    line-height: normal;\n    color: ",
        ";\n    & i {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  @media screen and (max-width: 991px) {\n    padding: 20px 20px;\n    .title {\n      & span {\n        font-size: 12px;\n      }\n      & h6 {\n        font-size: 18px;\n      }\n    }\n    .icon {\n      font-size: 2rem;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    padding: 20px;\n    .title {\n      & span {\n        font-size: 10px;\n      }\n      & h6 {\n        font-size: 16px;\n      }\n    }\n    .icon {\n      font-size: 28px;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    padding: 20px;\n    .title {\n      & span {\n        display: none;\n      }\n      & h6 {\n        font-size: 14px;\n      }\n    }\n    .icon {\n      font-size: 28px;\n    }\n  }\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 1px 1px 10px 0px rgba(112, 112, 112, 0.25);\n  display: flex;\n  justify-content: flex-start;\n  padding: 20px;\n  margin-bottom: 20px;\n  .cateSwiper {\n    width: 100%;\n    height: 100%;\n  }\n  @media screen and (max-width: 767px) {\n    overflow-x: hidden;\n\n    .cateSwiper {\n      width: 100%;\n      margin-left: 0px;\n      overflow: visible;\n      .swiper-wrapper {\n        width: 100%;\n      }\n      .swiper-slide {\n        margin-right: 15px !important;\n      }\n    }\n  }\n  @media screen and (max-width: 320px) {\n    .cateSwiper {\n      .swiper-slide {\n        min-width: 52px;\n        margin-right: 15px !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  word-break: keep-all;\n  text-align: center;\n  & span {\n    margin-top: 5px;\n    line-height: normal;\n    white-space: nowrap;\n  }\n  & figure {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    border-radius: 20px;\n    background-color: #f4f4f4;\n    padding: 10px;\n    border: ",
        ";\n  }\n  & img {\n    width: 100%;\n  }\n  :hover {\n    & span {\n      color: #3bb77e;\n    }\n  }\n  @media screen and (min-width: 1200px) {\n    & figure {\n      width: 115px;\n      height: 115px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & figure {\n      min-width: 52px;\n      min-height: 52px;\n      border-radius: 5px;\n      margin-bottom: 0px;\n      padding: 5px;\n    }\n    & span {\n      font-size: 11px;\n    }\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: -25px;\n  width: calc(100% + 50px);\n\n  & span {\n    position: absolute;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);\n    background-color: #fff;\n    color: #5a5a5a;\n    font-size: 19px;\n    cursor: pointer;\n    z-index: 9;\n    transition: all 0.1s ease 0s !important;\n    :hover {\n      background-color: #3bb77e;\n      color: #fff;\n    }\n  }\n  .custom_next_fct {\n    right: 0;\n  }\n  .custom_next_sct {\n    right: 0;\n  }\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n  grid-column: 2 span / 2 span;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  word-break: keep-all;\n  height: 226px;\n  margin-right: 25px;\n  & h5 {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: 1.8rem;\n    line-height: 1.5;\n  }\n  .more {\n    margin-top: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    border: none;\n    border-radius: 1000px;\n    background: #3bb77e;\n    color: #fff;\n    padding: 10px 20px;\n    line-height: normal;\n    & i {\n      margin-left: 10px;\n      margin-top: 2px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    :hover {\n      opacity: 0.8;\n    }\n  }\n  .mobile {\n    display: none;\n  }\n  @media screen and (max-width: 991px) {\n    .more {\n      font-size: 14px;\n      padding: 10px 20px;\n      white-space: nowrap;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    grid-column: 3 span / 3 span;\n    margin-right: 10px;\n    .more {\n      font-size: 12px;\n      padding: 10px 20px;\n      white-space: normal;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    grid-column: 10 span / 10 span;\n    height: fit-content;\n    margin-bottom: 20px;\n    & h5 {\n      display: none;\n    }\n    .more {\n      display: none;\n    }\n    .mobile {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      cursor: pointer;\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  grid-column: 8 span / 8 span;\n  width: 100%;\n  display: flex;\n  position: relative;\n  .swiper {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 50px;\n  }\n  .swiper-scrollbar-horizontal {\n    height: 2px;\n    width: calc(100% - 100px);\n    left: 0;\n    bottom: 14px;\n    background: rgba(59, 183, 126, 0.45);\n  }\n  .swiper-scrollbar-drag {\n    background-color: #3bb77e;\n  }\n\n  @media screen and (max-width: 767px) {\n    grid-column: 7 span / 7 span;\n\n    .swiper-scrollbar-horizontal {\n      width: calc(100% - 80px);\n    }\n    .swiper-pagination-fraction {\n      font-size: 12px;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    grid-column: 10 span / 10 span;\n    overflow: hidden;\n    justify-content: start;\n    .swiper {\n      overflow: visible;\n      width: 100%;\n      margin-left: 0px;\n      padding-bottom: 0px;\n    }\n    .swiper-slide {\n      min-width: 133px;\n      max-width: 133px;\n      margin-right: 20px !important;\n    }\n    .swiper-scrollbar-horizontal {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  cursor: pointer;\n  & figure {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    overflow: hidden;\n  }\n  @media screen and (max-width: 575px) {\n    & figure {\n      width: 133px;\n      height: 133px;\n    }\n  }\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  left: calc(100% - 100px);\n  width: 100px;\n  bottom: -7px;\n  padding: 0px 5px;\n  position: absolute;\n  display: grid;\n  align-items: center;\n  justify-content: flex-end;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 7px;\n  font-size: 24px;\n  z-index: 30;\n  & span {\n    cursor: pointer;\n    color: #3bb77e;\n    border: 1px solid #3bb77e;\n    border-radius: 10000px;\n    padding: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    & i {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    :hover {\n      color: #fff;\n      background-color: #3bb77e;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    font-size: 20px;\n    left: calc(100% - 70px);\n    width: 70px;\n    bottom: 0px;\n    gap: 5px;\n    & span {\n      width: 30px;\n      height: 30px;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 575px) {\n    .cateWrapper {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: none;\n  margin: 30px 0px 10px 0px;\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9c1975d0-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-1"
})(_templateObject1());
// 구역 구분
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-2"
})(_templateObject2());
var StickyHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-3"
})(_templateObject3());
var HeaderStepWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-4"
})(_templateObject4());
var HeaderStep = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-9c1975d0-5"
})(_templateObject5(), function(props) {
    return props.active ? "#198754" : "#6c757d";
});
var HeaderTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-9c1975d0-6"
})(_templateObject6());
var TitleShadow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-7"
})(_templateObject7());
// body
var Sidebar = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-8"
})(_templateObject8());
// 내용
var StepContents = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-9"
})(_templateObject9());
// 좌측 스텝 <-> categorysection
var StepSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-10"
})(_templateObject10());
var StepWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-11"
})(_templateObject11());
var CategorySection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-12"
})(_templateObject12());
var CategoryRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-13"
})(_templateObject13());
var SecondCategoryRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-14"
})(_templateObject14(), function(props) {
    return props.length < 3 ? "80%" : "100%";
}, function(props) {
    return props.length < 3 && "70%";
}, function(props) {
    return props.length < 2 && "30%";
}, function(props) {
    return props.length < 3 ? "repeat(".concat(props.length, ", 1fr)") : "repeat(3, 1fr)";
});
var CategoryBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-15"
})(_templateObject15(), function(props) {
    return props.second ? "100%" : "100%";
}, function(props) {
    return props.second ? "17rem" : "17rem";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.selected) === null || ref === void 0 ? void 0 : ref.name) === props.boxName ? "2px solid #3bb77e" : "2px solid #ececec";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.catSelect) === props.boxId ? "2px solid #3bb77e" : "2px solid  #bce3c9";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.catSelect) === props.boxId ? "2px solid #3bb77e" : "2px solid  #bce3c9";
});
// secondStep
var CheckboxDiv = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-16"
})(_templateObject16());
var SelectedStepCommonInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c1975d0-17"
})(_templateObject17());
var SelectedStepBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-18"
})(_templateObject18());
// 컨텐츠 부분
var BodyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-19"
})(_templateObject19());
// 좌측 사이드 스티커
var SideStickyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-20"
})(_templateObject20());
var StickyContents = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-21"
})(_templateObject21());
var SideImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-22"
})(_templateObject22());
var SideInfoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-23"
})(_templateObject23());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-24"
})(_templateObject24());
var ContentBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-25"
})(_templateObject25());
var ContentBoxTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-9c1975d0-26"
})(_templateObject26());
var BoxItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-27"
})(_templateObject27(), function(props) {
    return props.grid ? "grid" : "flex";
}, function(props) {
    return props.row ? "row" : "column";
});
var BtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-28"
})(_templateObject28());
// 최하단 footer
var FooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-29"
})(_templateObject29());
var FooterTableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-30"
})(_templateObject30());
var TableBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c1975d0-31"
})(_templateObject31());
var FooterBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-32"
})(_templateObject32());
// customizingSlider
var CustomizingSliderSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9c1975d0-33"
})(_templateObject33());
var LeftBigBanner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-34"
})(_templateObject34());
var LeftBigSlide = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-35"
})(_templateObject35());
var RightSmallBanner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-36"
})(_templateObject36());
var RightSmallSlide = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-37"
})(_templateObject37());
var MobileBanner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-38"
})(_templateObject38());
// 견적 바구니
var CustomCartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-39"
})(_templateObject39(), function(props) {
    return props.new ? "none" : " 1px 1px 10px 0px rgba(112, 112, 112, 0.25)";
}, function(props) {
    return props.new ? "50px" : "20px";
}, function(props) {
    return props.new ? "none" : " 15px 20px";
});
// customizingCate
var CustomizingCateSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9c1975d0-40"
})(_templateObject40());
var TypeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-41"
})(_templateObject41());
var TypeBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c1975d0-42"
})(_templateObject42(), function(props) {
    return props.categoryType ? "#3bb77e" : "#f1f1f1";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
}, function(props) {
    return props.categoryType ? "#fff" : "#565656";
});
var CategoryWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-43"
})(_templateObject43());
var CateBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-44"
})(_templateObject44(), function(props) {
    return props.active ? "3px solid #3bb77e" : "none";
});
var SlideArrows = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-45"
})(_templateObject45());
// 제작사례 & 포장재리뷰
var PortFolioSliderSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9c1975d0-46"
})(_templateObject46());
var SliderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-47"
})(_templateObject47());
var SliderTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-48"
})(_templateObject48());
var Slider = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-49"
})(_templateObject49());
var PortfolioBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-50"
})(_templateObject50());
var PortfolioSliderArrows = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-51"
})(_templateObject51());
// 맞춤제작 세부
var CustomNewSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9c1975d0-52"
})(_templateObject52());
var CustomMobileTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c1975d0-53"
})(_templateObject53());


/***/ }),

/***/ 30075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8701);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30719);
/* harmony import */ var _Customizing_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85140);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36968);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_makeCategorys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47597);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55150);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Scrollbar */ .LW,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Grid */ .rj
]);
var CustomizingCate = function(param) {
    var cateRef = param.cateRef;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), firstCateSwiper = ref13[0], setFirstCateSwiper = ref13[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), secondCateSwiper = ref1[0], setSecondCateSwiper = ref1[1];
    // 카테고리 타입
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("S"), categoryType = ref2[0], setCategoryType = ref2[1];
    // 1차 카테고리 리스트
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), firstCategoryList = ref3[0], setFirstCategoryList = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), firstCategory = ref4[0], setFirstCategory = ref4[1];
    // 2차 카테고리 리스트
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), secondCategoryList = ref5[0], setSecondCategoryList = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), secondCategory = ref6[0], setSecondCategory = ref6[1];
    // 카테고리 불러오기 loading
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), cateLoading = ref7[0], setCateLoading = ref7[1];
    var handleCategoryType = function(type) {
        setCategoryType(type);
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        setFirstCategory("");
        router.push({
            pathname: "",
            query: {
                type: type
            }
        });
    };
    // N차 카테고리 불러오기
    var fetchCategoryList = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(depth, el1) {
            var body, res, ref, ref8, ref9, first, ref10, ref11, ref12;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "CategoryListSet",
                            division: router.query.type || categoryType,
                            code: (el1 === null || el1 === void 0 ? void 0 : el1.code) ? el1.code : ""
                        };
                        _ctx.next = 3;
                        return (0,_api_makeCategorys__WEBPACK_IMPORTED_MODULE_7__/* .CategoryListSet */ .w)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code !== "0000")) {
                            _ctx.next = 7;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (0,_common_alert__WEBPACK_IMPORTED_MODULE_8__/* .failAlert */ .qh)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uCE74\uD14C\uACE0\uB9AC \uC694\uCCAD \uC2E4\uD328"));
                    case 7:
                        if (!(depth === 1)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        setFirstCategoryList((ref8 = res.Data) === null || ref8 === void 0 ? void 0 : ref8.Category);
                        if (router.query.first) {
                            ;
                            first = (ref9 = res.Data) === null || ref9 === void 0 ? void 0 : ref9.Category.find(function(el) {
                                return el.code === router.query.first;
                            });
                            setFirstCategory(first);
                            fetchCategoryList(2, first);
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        if (depth === 2) {
                            ;
                            setSecondCategoryList((ref10 = res.Data) === null || ref10 === void 0 ? void 0 : ref10.Category);
                            if (!((ref11 = res.Data) === null || ref11 === void 0 ? void 0 : ref11.Category) || ((ref12 = res.Data) === null || ref12 === void 0 ? void 0 : ref12.Category.length) < 1) {
                                setSecondCategory(el1);
                            } else {
                                setCateLoading(false);
                            }
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCategoryList(depth, el1) {
            return _ref.apply(this, arguments);
        };
    }();
    // 1차 카테고리 선택 함수
    var selectFirstCategory = function(el) {
        return _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCateLoading(true);
                        setSecondCategory("");
                        setSecondCategoryList([]);
                        setFirstCategory(el);
                        _ctx.next = 6;
                        return fetchCategoryList(2, el);
                    case 6:
                        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                            x: window.scrollX,
                            y: window.scrollY
                        }));
                        router.push({
                            pathname: "",
                            query: _objectSpread({}, router.query, {
                                first: el.code,
                                code: ""
                            })
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    // 2차 카테고리 선택 함수
    var selectSecondCategory = function(el) {
        return _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSecondCategory(el);
                        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                            x: window.scrollX,
                            y: window.scrollY
                        }));
                        if (cateRef) {
                            setTimeout(function() {
                                window.scrollTo({
                                    behavior: "smooth",
                                    left: 0,
                                    top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                                });
                            }, [
                                200
                            ]);
                        }
                        router.push({
                            pathname: "/customizing/customizing-products/new",
                            query: _objectSpread({}, router.query, {
                                code: el.code
                            })
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setCateLoading(true);
        if (!router.isReady) return;
        if (router.query.type) {
            setCategoryType(router.query.type);
        } else {
            setCategoryType("S");
        }
        fetchCategoryList(1);
        if (cateRef && !secondCategory && !firstCategory && router.query.code) {
            setTimeout(function() {
                window.scrollTo({
                    behavior: "smooth",
                    left: 0,
                    top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                });
                setCateLoading(false);
            }, [
                300
            ]);
        }
        var routeChangeCompleteHandler = function() {
            // 페이지 이동 후 저장되어 있던 위치로 스크롤 복원
            var _scroll = sessionStorage.getItem("__next_scroll_".concat(router.pathname));
            if (_scroll) {
                // 스크롤 복원 후 저장된 위치 제거
                var ref = JSON.parse(_scroll), x = ref.x, y = ref.y;
                window.scrollTo(x, y);
                sessionStorage.removeItem("__next_scroll_".concat(router.pathname));
            }
        };
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        setCateLoading(false);
        return function() {
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady,
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            cateLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "loading_container position-fixed d-flex align-items-center justify-content-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    animation: "border",
                    role: "status"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .CustomizingCateSection */ .JY, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .TypeWrapper */ .f3, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .TypeBtn */ .wh, {
                                categoryType: categoryType === "S",
                                onClick: function() {
                                    return handleCategoryType("S");
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "title",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: "\uC6D0\uD558\uC2DC\uB294 \uD3EC\uC7A5\uC7AC\uAC00 \uC788\uC73C\uC2E0\uAC00\uC694?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                children: "\uD3EC\uC7A5\uC7AC \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-check-circle"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .TypeBtn */ .wh, {
                                categoryType: categoryType === "T",
                                onClick: function() {
                                    return handleCategoryType("T");
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "title",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: "\uC5B4\uB5A4 \uD3EC\uC7A5\uC7AC\uB97C \uACE8\uB77C\uC57C \uB420\uC9C0 \uC5B4\uB824\uC6B0\uC2E0\uAC00\uC694?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                                children: "\uD3EC\uC7A5 \uD560 \uC81C\uD488\uC744 \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-check-circle"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    categoryType && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .CategoryWrapper */ .MJ, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                id: "firstCateSwiper",
                                className: "cateSwiper",
                                navigation: {
                                    prevEl: ".custom_prev_fct",
                                    nextEl: ".custom_next_fct"
                                },
                                slidesPerView: 4,
                                slidesPerGroup: 4,
                                centeredSlides: false,
                                breakpoints: {
                                    991: {
                                        slidesPerView: 7,
                                        slidesPerGroup: 7
                                    },
                                    768: {
                                        slidesPerView: 6,
                                        slidesPerGroup: 6
                                    }
                                },
                                initialSlide: 0,
                                spaceBetween: 20,
                                grabCursor: true,
                                observer: true,
                                onSwiper: setFirstCateSwiper,
                                onSlideChange: function(swiper) {
                                    return setFirstCateSwiper(_objectSpread({}, firstCateSwiper, {
                                        realIndex: swiper.realIndex
                                    }));
                                },
                                children: firstCategoryList && firstCategoryList.map(function(cate, cateIdx) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .CateBox */ .Ui, {
                                            onClick: selectFirstCategory(cate),
                                            active: (firstCategory === null || firstCategory === void 0 ? void 0 : firstCategory.code) === cate.code || false,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figure", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                        src: cate.image,
                                                        alt: cate.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: cate.name
                                                })
                                            ]
                                        })
                                    }, cateIdx);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .SlideArrows */ .WN, {
                                className: "slider-arrow",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "custom_prev_fct",
                                        style: {
                                            visibility: firstCateSwiper && (firstCateSwiper === null || firstCateSwiper === void 0 ? void 0 : firstCateSwiper.realIndex) == 0 ? "hidden" : "visible"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-angle-left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "custom_next_fct",
                                        style: {
                                            visibility: firstCateSwiper && (firstCateSwiper === null || firstCateSwiper === void 0 ? void 0 : firstCateSwiper.realIndex) + (Number(firstCateSwiper === null || firstCateSwiper === void 0 ? void 0 : firstCateSwiper.currentBreakpoint) < 991 ? 6 : 7) >= (firstCategoryList === null || firstCategoryList === void 0 ? void 0 : firstCategoryList.length) ? "hidden" : "visible"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-angle-right"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    firstCategory && secondCategoryList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .CategoryWrapper */ .MJ, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                id: "secondCateSwiper",
                                className: "cateSwiper",
                                navigation: {
                                    prevEl: ".custom_prev_sct",
                                    nextEl: ".custom_next_sct"
                                },
                                slidesPerView: 4,
                                slidesPerGroup: 4,
                                centeredSlides: false,
                                breakpoints: {
                                    991: {
                                        slidesPerView: 7,
                                        slidesPerGroup: 7
                                    },
                                    768: {
                                        slidesPerView: 6,
                                        slidesPerGroup: 6
                                    }
                                },
                                initialSlide: 0,
                                spaceBetween: 20,
                                grabCursor: true,
                                observer: true,
                                onSwiper: setSecondCateSwiper,
                                onSlideChange: function(swiper) {
                                    return setSecondCateSwiper(_objectSpread({}, secondCateSwiper, {
                                        realIndex: swiper.realIndex
                                    }));
                                },
                                children: secondCategoryList.map(function(cate, cateIdx) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .CateBox */ .Ui, {
                                            onClick: selectSecondCategory(cate),
                                            active: router.query.code === cate.code,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figure", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                        src: cate.image,
                                                        alt: cate.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: cate.name
                                                })
                                            ]
                                        })
                                    }, cateIdx);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_5__/* .SlideArrows */ .WN, {
                                className: "slider-arrow",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "custom_prev_sct",
                                        style: {
                                            visibility: secondCateSwiper && (secondCateSwiper === null || secondCateSwiper === void 0 ? void 0 : secondCateSwiper.realIndex) == 0 ? "hidden" : "visible"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-angle-left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "custom_next_sct",
                                        style: {
                                            visibility: secondCateSwiper && (secondCateSwiper === null || secondCateSwiper === void 0 ? void 0 : secondCateSwiper.realIndex) + 7 >= (secondCategoryList === null || secondCategoryList === void 0 ? void 0 : secondCategoryList.length) ? "hidden" : "visible"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-angle-right"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomizingCate);


/***/ }),

/***/ 42682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8701);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30719);
/* harmony import */ var _Customizing_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85140);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






swiper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Scrollbar */ .LW,
    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rj
]);
var PortfolioSlider = function(param) {
    var gallery = param.gallery;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), portfolioSlider = ref[0], setPortfolioSlider = ref[1];
    var onClickMore = function() {
        router.push("/esg-guide/blog/make/");
    };
    var onClickDetail = function(el) {
        router.push("/esg-guide/post/".concat(el.id, "/"));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .PortFolioSliderSection */ .t7, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .SliderWrapper */ .h2, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .SliderTitle */ .nz, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                                children: [
                                    "\uB9DE\uCDA4\uC81C\uC791 ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    "\uC0AC\uB840"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                className: "more",
                                onClick: function() {
                                    return onClickMore();
                                },
                                children: [
                                    "\uB354 \uBCF4\uB7EC\uAC00\uAE30 ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-right"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        onClick: function() {
                                            return onClickMore();
                                        },
                                        children: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-right",
                                        onClick: function() {
                                            return onClickMore();
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .Slider */ .iR, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                                id: "portfolioSwiper",
                                className: "portfolioSwiper",
                                navigation: {
                                    prevEl: ".custom_prev_pf",
                                    nextEl: ".custom_next_pf"
                                },
                                //   loop={true}
                                slidesPerView: 2,
                                centeredSlides: false,
                                breakpoints: {
                                    991: {
                                        slidesPerView: 4
                                    },
                                    767: {
                                        slidesPerView: 3
                                    },
                                    575: {
                                        slidesPerView: 2
                                    }
                                },
                                scrollbar: {
                                    hide: false
                                },
                                initialSlide: 0,
                                spaceBetween: 20,
                                grabCursor: true,
                                observer: true,
                                onSwiper: setPortfolioSlider,
                                onSlideChange: function(swiper) {
                                    return setPortfolioSlider(_objectSpread({}, portfolioSlider, {
                                        realIndex: swiper.realIndex
                                    }));
                                },
                                children: gallery && gallery.map(function(el, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                        id: "portfolioSlide",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .PortfolioBox */ .J, {
                                            onClick: function() {
                                                return onClickDetail(el);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: el.thumbnail
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: el.title
                                                })
                                            ]
                                        })
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Customizing_styles__WEBPACK_IMPORTED_MODULE_4__/* .PortfolioSliderArrows */ .Sc, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "custom_prev_pf",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-angle-small-left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "custom_next_pf",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-angle-small-right"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PortfolioSlider);


/***/ })

}]);